<template>
 	<div class="flex-colum h-100">
		<div class="d-flex justify-content-between bd-highlight mb-3">
			<div class="align-self-center mb-3" style="height: 30px;">
			    <button type="button" class="btn btn-primary" @click="tongji">统计</button>
			</div>
		    <div class="input-group align-self-center ms-auto p-2 bd-highlight" style="width: 25%;">
		        <input type="text" class="form-control" v-model="keywords">
		        <button class="btn btn-outline-secondary" type="button" @click="searchYuyue">搜索</button>
		    </div>
		</div>
		<div>
			<table class="table table-bordered table-striped table-sm member-list">
				<thead>
					<tr>
						<th scope="col">序号</th><th scope="col">姓名</th><th scope="col">手机号</th><th scope="col">预约门店</th><th scope="col">操作时间</th>
					</tr>
				</thead>
				<tbody id="member-list">
					<tr v-for="(value, idx) in dataList" :key='idx'>
						<td>{{50 * (nowPage - 1) + idx + 1}}</td>
						<td>{{value.name}}</td>
						<td>{{value.mobile}}</td>
						<td>{{value.shopName || "-"}}</td>
						<td>{{dateFtt('yyyy-MM-dd hh:mm', new Date(value.operateTime))}}</td>
						<td>
							<div class="flex-row flex-align-center">
								<img class="button-icon" src="/assets/ic_edit.png" @click="openEditYuyueDialog(value.id)"/>
								<img class="button-icon img-margin" src="/assets/ic_trash.png" @click="deleteYuyue(value.id, value.name)"/>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<Pagination :page='nowPage' :max='totalPage/50' @loadPage="loadYuyueList" />
		</div>
	</div>
	
	<!-- <AddYuyueDialog :show='showAddDialog' :item='editing' @cancel='showAddDialog = false' @confirm='editYuyue'/> -->
	<LoadingDialog :show='showLoadingDialog' />
</template>

<script lang="ts">
import { reactive, toRefs, defineComponent, nextTick, onMounted, ref, watch, computed } from 'vue';
import Pagination from '@/components/Pagination.vue';
import LoadingDialog from '@/modals/LoadingDialog.vue';
import { DEFAULTS } from "@/global";
import { checkResponseDataAndAlert, dateFtt, buildHttpHeader } from '@/common/util';
import axios from 'axios';

export default({
	components: { Pagination, LoadingDialog },
	setup() {
		const refData = reactive({
			showAddDialog: false,
			showLoadingDialog: false,
			keywords: "搜索",
			editing: {}
		});
		
		const totalPage = ref<number>(0);
		const nowPage = ref<number>(1);
		const dataList = ref<any[]>([]);
		
		//needed in case we switch in from another window
		onMounted(async () => {
		  await loadYuyueList(1);
		});
		
		// ========================文章标签========================
		// 添加标签
		const openAddYuyueDialog = () => {
			refData.editing = {};
			refData.showAddDialog = true;
		};
		
		// 编辑信息
		const openEditYuyueDialog = async (id: string) => {
		    const errMsg = "查询信息失败";
			try {
				const data = (await axios.get(`${DEFAULTS.URL}yuyue/${id}`, {headers: buildHttpHeader()})).data;
		        if (checkResponseDataAndAlert(data, errMsg) && data.data) {
					refData.editing = data.data;
					refData.showAddDialog = true;
		        }
			} catch (e) {
				console.log(e);
				checkResponseDataAndAlert({}, errMsg);
			}
		}
		
		// 编辑
		const editYuyue = async (postObj: any) =>  {
			console.log(postObj)
		    const errMsg = `操作失败`;		
			if (!postObj.name || postObj.name.length < 2
				|| !postObj.city || postObj.city.length < 2
				|| !postObj.address || postObj.address.length < 2
				|| !postObj.image || postObj.image.length < 2) {
				alert("请完善带*的必填项");
				return;
			}
		
		    refData.showLoadingDialog = true;
			try {
				const data = (await axios.post(`${DEFAULTS.URL}yuyue/save`, postObj, {headers: buildHttpHeader()})).data;
				refData.showLoadingDialog = false;
		        if (checkResponseDataAndAlert(data, errMsg)) {
					refData.showAddDialog = false;
		            loadYuyueList(nowPage.value);
		        }
			} catch (e) {
				console.log(e);
				refData.showLoadingDialog = false;
				checkResponseDataAndAlert({}, errMsg);
			}
		}
		
		// 删除
		const deleteYuyue = async (card_no: string, name: string) => {
			if (confirm(`确认删除 ${name} 吗？`)) {
				const errMsg = "删除失败";
				try {
					const data = (await axios.get(`${DEFAULTS.URL}yuyue/delete/${card_no}`, {headers: buildHttpHeader()})).data;
					if (checkResponseDataAndAlert(data, errMsg)) {
						alert("删除成功");
						loadYuyueList(nowPage.value);
					}
				} catch (e) {
					checkResponseDataAndAlert({}, errMsg);
				}
			}
		};
		
		// 搜索
		const searchYuyue = async () => {
		    if (refData.keywords.length === 0) {
		        loadYuyueList(1);
		        return;
		    }
		
		    nowPage.value = 1;
			try {
				const postObj = {"page" : 1, "size": 50, "content": refData.keywords, timestamp: Date.now() };
				const data = (await axios.post(`${DEFAULTS.URL}yuyue/search`, postObj, {headers: buildHttpHeader()})).data
		        if (checkResponseDataAndAlert(data) && data.data) {
					dataList.value = data.data;
					totalPage.value = data.total;
				}
			} catch (e) {
				checkResponseDataAndAlert({});
			}
		}
			
		// 加载列表
		const  loadYuyueList = async (page: number) => {
		    if (page < 1) return;
		
		    nowPage.value = page;
			try {
				const data = (await axios.get(`${DEFAULTS.URL}yuyue/list/${page}/${50}`, {headers: buildHttpHeader()})).data;
				if (checkResponseDataAndAlert(data) && data.data) {
				    dataList.value = data.data;
					totalPage.value = data.total;
				}
			} catch (e) {
				checkResponseDataAndAlert({});
			}
		};
		
		// 加载列表
		const tongji = async () => {
			let tjPage = 1;
			let shop = "63281616c29d7466319b612c0";
			let start = "2022-09-01";
			let end = "2022-09-30";
			let text = "客户编码,客户姓名,来源渠道,参观类型,参观时间,参观门店\n"
			while (true) {
				try {
					const url = `${DEFAULTS.URL}visit/list/${tjPage}/${100}?shop=${shop}&start=${start}&end=${end}`;
					const data = (await axios.get(url, {headers: buildHttpHeader()})).data;
					if (checkResponseDataAndAlert(data) && data.data) {
						console.log("fetched: " + data.data.length);
						for (const item of data.data) {
							text  += `${item.customer},${item.profile.name},${item.profile.channel},${item.type},${item.realVisitDate||item.visitDate},${item.shopName}\n`;
						}
						if(data.data.length === 0) break;
						tjPage += 1;
					}
				} catch (e) {
					checkResponseDataAndAlert({});
				}
			}
			console.log(text);
		};
		
		const dataRef = toRefs(refData);
		return {
			dataList,
			nowPage,
			totalPage,
			
			tongji,
			dateFtt,
			editYuyue,
			loadYuyueList,
			openAddYuyueDialog,
			openEditYuyueDialog,
			deleteYuyue,
			
			...dataRef
		};
	},
});
</script>

<style>
</style>